<div class="option-picker" #picker [attr.data-placement]="placement()">
  @if (triggerIconSvg()) {
    <button
      class="option-picker-trigger option-picker-trigger--icon"
      type="button"
      [attr.aria-expanded]="isOpen()"
      aria-haspopup="listbox"
      aria-controls="option-picker-options"
      [attr.aria-label]="ariaLabel()"
      (click)="toggle()"
    >
      <span class="option-picker-icon" [innerHTML]="triggerIconHtml()"></span>
    </button>
  } @else {
    <button
      class="option-picker-trigger"
      type="button"
      [class.has-value]="selectedOption() !== undefined"
      [attr.aria-expanded]="isOpen()"
      aria-haspopup="listbox"
      aria-controls="option-picker-options"
      (click)="toggle()"
    >
      <span class="option-picker-label">{{ triggerLabel() }}</span>
      <svg
        class="option-picker-chevron"
        viewBox="0 0 12 12"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M2.5 4.5 6 8l3.5-3.5" />
      </svg>
    </button>
  }

  @if (isOpen()) {
    <div class="option-picker-options" id="option-picker-options" role="listbox" [attr.aria-label]="ariaLabel()">
      @for (option of options(); track option.value) {
        <button
          type="button"
          role="option"
          [attr.aria-selected]="option.value === selectedValue()"
          [class.is-selected]="option.value === selectedValue()"
          [class.is-danger]="option.danger"
          (click)="selectOption(option.value)"
        >
          @if (option.icon) {
            <span class="option-picker-option-icon" [innerHTML]="optionIconHtml(option.icon)"></span>
          }
          <span class="option-picker-option-text">
            <span class="option-picker-option-label">{{ option.label }}</span>
            @if (option.description) {
              <small>{{ option.description }}</small>
            }
          </span>
        </button>
      }
    </div>
  }
</div>
